import { render, staticRenderFns } from "./UIModal.vue?vue&type=template&id=962e126c"
import script from "./UIModal.vue?vue&type=script&lang=js"
export * from "./UIModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports